// src/components/store/sections/faqs/FaqV19SteppernumberedFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV19SteppernumberedFuchsiaGlow(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={19}
      archKey="stepper_numbered"
      archLabel="Numbered Stepper FAQ"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
